import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { DefaultCellRenderer } from '../utils';
import type { ColumnWidth } from '../utils/calculateColumnWidths';
import Cell from './elements/Cell';
import { ColumnConfig, type ColumnField } from './types';
type CommonColumnWidth = Pick<ColumnWidth, 'width' | 'minWidth' | 'maxWidth'>;
function ValueCell(t0) {
  const $ = _c(14);
  let children;
  let className;
  let render;
  let value;
  let widths;
  if ($[0] !== t0) {
    ({
      render,
      value,
      children,
      className,
      ...widths
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = render;
    $[4] = value;
    $[5] = widths;
  } else {
    children = $[1];
    className = $[2];
    render = $[3];
    value = $[4];
    widths = $[5];
  }
  const Content = render ?? DefaultCellRenderer;
  let t1;
  if ($[6] !== Content || $[7] !== value) {
    t1 = <Content value={value} />;
    $[6] = Content;
    $[7] = value;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== children || $[10] !== className || $[11] !== t1 || $[12] !== widths) {
    t2 = <Cell {...widths} className={className}>{children}{t1}</Cell>;
    $[9] = children;
    $[10] = className;
    $[11] = t1;
    $[12] = widths;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
export default ValueCell;